import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import Boxoutline from "../../../../media/images/icons/outline-box";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left";
import { blueGrey, grey } from "@mui/material/colors";
import CustomButton from "../../../components/CustomButton";
import { addCommas } from "@persian-tools/persian-tools";
import MultipleSimple from "../../../../media/images/icons/multiple-simple";
import CancleOrderModal from "./CancleOrderModal";
import { useAppSelector } from "../../../../hooks/useRedux";
import { IOrder } from "../../../../types/owner";

interface Props {
  order: IOrder;
  handleOrderState: () => void;
  handleCancleOrder: (id: string) => void;
}

export default function OrderDetailsV2(props: Props) {
  const {
    code,
    truckCount,
    receiverAddress,
    senderAddress,
    // registrationInfo,
    id,
    // receiverInfo,
    // goodsCost,
    goodsInfo,
    // companyName,
    // senderInfo,
    type,
    loaderTypeGroup,
    fare,
    isConfirm,
    packageTypeInfo,
    truckWeight,
    truckWeightTo,
    loadingTime,
    loadingToTime,
  } = props.order;
  const weightTo =
    truckWeightTo ??
    (props.order as IOrder & { TruckWeightTo?: number | null }).TruckWeightTo;
  const timeFrom =
    loadingTime ||
    (props.order as IOrder & { LoadingTime?: string | null }).LoadingTime;
  const timeTo =
    loadingToTime ||
    (props.order as IOrder & { LoadingToTime?: string | null }).LoadingToTime;
  const { handleOrderState, handleCancleOrder } = props;

  const [cancelModal, setCancleModal] = useState(false);
  const theme = useTheme();

  const { stock } = useAppSelector((state) => state.owner);

  return (
    <>
      <CancleOrderModal
        id={id}
        onOk={() => handleCancleOrder(id)}
        open={cancelModal}
        setOpen={setCancleModal}
      />
      <Box>
        <Box
          sx={{
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
            display: "flex",
            // border: "1px solid gray",
            mt: 2,
            border: "1px solid",
            borderColor: grey[100],
            gap: "4px",
            borderWidth: "1px",
            borderRadius: "16px",
            flexDirection: "column",
            padding: "8px",
            backgroundColor: "bgColor.white",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "info.light",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px",
                borderRadius: "8px",
              }}
            >
              <Boxoutline color={theme.palette.textColor.main} />
            </Box>
            <Box
              sx={{
                flex: "1",
                // border: "1px solid gray",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  نام محموله: {goodsInfo?.name || "-----"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    // backgroundColor: "primary.light",
                    padding: "4px",
                    borderRadius: "8px",
                    gap: "4px",
                  }}
                >
                  {/* <BigCarIcon2 color={theme.palette.primary.main} /> */}
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    شماره سفارش:{" "}
                  </Typography>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontSize: "14px",
                    }}
                  >
                    {code}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              کد رهگیری بارنامه:
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {id}
            </Typography>
          </Box> */}
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              وضعیت سفارش :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {isConfirm === null
                ? "در انتظار تایید"
                : isConfirm
                ? "تایید شده"
                : "عدم تایید"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              تعداد کامیون :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {truckCount}
            </Typography>
          </Box>
          {/* فرم ساده‌شده صاحب کالا این مشخصه را دریافت نمی‌کند؛ برای امکان بازگردانی فقط کامنت شده است.
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              شرکت حمل و نقل:{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {companyName}
            </Typography>
          </Box>
          */}

          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              گروه بارگیر :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {loaderTypeGroup || "-----"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              نوع بسته بندی :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {packageTypeInfo?.name || "-----"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              وزن محموله از :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {truckWeight ? `${addCommas(truckWeight)} کیلوگرم` : "-----"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              وزن محموله تا :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {weightTo ? `${addCommas(weightTo)} کیلوگرم` : "-----"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              ساعت بارگیری از :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {timeFrom || "-----"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              ساعت بارگیری تا :
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {timeTo || "-----"}
            </Typography>
          </Box>
          {/* ارزش محموله از فرم ساده‌شده حذف شده است؛ برای امکان بازگردانی فقط کامنت شده است.
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              ارزش محموله :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {addCommas(goodsCost)}ریال
            </Typography>
          </Box>
          */}
          {/* مشخصات هویتی فرستنده از فرم ساده‌شده حذف شده است؛ برای امکان بازگردانی فقط کامنت شده است.
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              نام فرستنده :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {senderInfo?.name}
            </Typography>
          </Box>
          */}
          {/* کدملی فرستنده از فرم ساده‌شده حذف شده است؛ برای امکان بازگردانی فقط کامنت شده است.
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              کدملی فرستنده :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {senderInfo?.nationID}
            </Typography>
          </Box>
          */}
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              مبدأ :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {senderAddress?.cityName || "-----"}
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              آدرس محل بارگیری :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {senderAddress?.address || "-----"}
            </Typography>
          </Box>
          {/* مشخصات گیرنده از فرم ساده‌شده حذف شده است؛ برای امکان بازگردانی فقط کامنت شده است.
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              نام گیرنده :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {receiverInfo?.name}
            </Typography>
          </Box>
          */}
          {/* کدملی گیرنده از فرم ساده‌شده حذف شده است؛ برای امکان بازگردانی فقط کامنت شده است.
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              کدملی گیرنده:{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {receiverInfo?.nationID}
            </Typography>
          </Box>
          */}
          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              border: "1px solid",
              borderColor: blueGrey[100],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              مقصد :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {receiverAddress?.address}
            </Typography>
          </Box>

          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "3px solid",
              borderColor: blueGrey[100],
              backgroundColor: theme.palette.primary[50],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "16px",
                fontWeight: "700",
                color: grey[800],
              }}
            >
              کرایه بار :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {addCommas(fare || "") || "------"} ریال
            </Typography>
          </Box>

          <hr
            style={{
              border: "1px dashed grey",
              width: "100%",
            }}
          />

          <Box
            sx={{
              borderRadius: "6px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "3px solid",
              borderColor: grey[100],
              backgroundColor: theme.palette.secondary[50],
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                color: grey[800],
              }}
            >
              موجودی کیف پول :{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
              }}
              color="success.main"
            >
              {addCommas(stock || "0")} ریال
            </Typography>
          </Box>

          {/* <CustomButton
            rippleColor={theme.palette.info.dark}
            flex={1}
            justifyContent="center"
            // loading
            onClick={() => navigate("../wallet")}
            title="افزایش اعتبار کیف پول"
            bgColor="success.main"
            textColor="#fff"
            //   borderColor="success.dark"
            px="10px"
            py="12px"
            borderRadius="6px"
            // icon1={<EyeSVG size={22} color={"#fff"} />}
          /> */}
          <CustomButton
            type="outlined"
            rippleColor={theme.palette.info.dark}
            flex={1}
            onClick={() => setCancleModal(true)}
            // loading
            //   flexDirection="row-reverse"
            // onClick={() =>
            //   deleteTenderOffer({
            //     id,
            //   })
            // }
            justifyContent="center"
            title="لغو سفارش"
            bgColor="error.light"
            textColor="error.main"
            borderColor="error.main"
            fWeight="700"
            fSize="14px"
            px="10px"
            py="12px"
            mt="8px"
            borderRadius="8px"
            icon1={
              <MultipleSimple color={theme.palette.error.main} size={18} />
            }
          />

          <CustomButton
            rippleColor={theme.palette.info.dark}
            flex={1}
            justifyContent="center"
            // loading
            onClick={handleOrderState}
            title="بستن جزییات"
            bgColor="primary.main"
            textColor="#fff"
            //   borderColor="success.dark"
            px="10px"
            py="12px"
            borderRadius="6px"
            // icon1={<EyeSVG size={22} color={"#fff"} />}
          />
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 700,
          fontSize: "14px",
        }}
      >
        مدیریت بارها{" "}
      </Typography>
      <ArrowTickLeft size={14} color={theme.palette.info.dark} />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        جزئیات سفارش{" "}
      </Typography>
    </Box>
  );
}
